import type { ITrainingOffer } from "@bbj-types/offer";
import { useCallback } from "react";
import { axios } from "../axios";

export type TTrainingOfferModify = Omit<
  ITrainingOffer,
  "externalId" | "isExpired" | "active" | "publicationDate" | "publicationUpdatedDate"
>;

export const usePutTrainingOffer = () => {
  const [state, execute, cancel] = axios<ITrainingOffer, TTrainingOfferModify, unknown>(
    {
      url: "/offers/training",
      method: "put",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (trainingOffer: TTrainingOfferModify) => {
      return execute({ data: trainingOffer });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
